import { fetchJSON } from './http';

type CheckClientPayload = { email?: string; phone?: string };
type CheckClientResponse = { success: boolean; clientExists: boolean; client?: any };

type SendOtpPayload = { clientId: string };
type SendOtpResponse = {
  success: boolean;
  attemptsLeft?: number;
  otpValidityMinutes?: number;
  otpChannel?: 'email' | 'sms';
  destinationHint?: string;
  otp?: string;
  message?: string;
};

type VerifyOtpPayload = { clientId: string; otp: string };
type VerifyOtpResponse = { success: boolean; client?: any; attemptsLeft?: number; requireResend?: boolean; message?: string };

type CheckDuplicatePayload = { email?: string | null; phone?: string | null };
type CheckDuplicateResponse = {
  success: boolean;
  exists: boolean;
  field?: 'email' | 'phone';
  fields?: Array<'email' | 'phone'>;
  client?: any;
};

type CreateAnonymousPayload = {
  firstName?: string;
  preferredLanguage?: 'fr' | 'en';
};

type CreateAnonymousResponse = {
  success: boolean;
  message?: string;
  data?: {
    client?: {
      id: string;
      firstName?: string;
      lastName?: string;
      email?: string;
      phone?: string;
      isAnonymous?: boolean;
      anonymousCode?: string;
      preferredLanguage?: 'fr' | 'en';
    };
  };
  errors?: Array<{ field: string; message: string }>;
};

export const clientApi = {
  checkClient(payload: CheckClientPayload): Promise<CheckClientResponse> {
    return fetchJSON<CheckClientResponse>('/api/appointments/check-client', { method: 'POST', body: payload });
  },
  sendOtp(payload: SendOtpPayload): Promise<SendOtpResponse> {
    return fetchJSON<SendOtpResponse>('/api/appointments/piercing/send-otp', { method: 'POST', body: payload });
  },
  verifyOtp(payload: VerifyOtpPayload): Promise<VerifyOtpResponse> {
    return fetchJSON<VerifyOtpResponse>('/api/appointments/verify-otp', { method: 'POST', body: payload });
  },
  resendOtp(payload: { clientId: string }): Promise<{
    success: boolean;
    attemptsLeft?: number;
    message?: string;
    otpChannel?: string;
    destinationHint?: string;
  }> {
    return fetchJSON('/api/appointments/resend-otp', { method: 'POST', body: payload });
  },
  checkDuplicate(payload: CheckDuplicatePayload): Promise<CheckDuplicateResponse> {
    return fetchJSON<CheckDuplicateResponse>('/api/clients/check-duplicate', { method: 'POST', body: payload });
  },
  createAnonymous(payload: CreateAnonymousPayload): Promise<CreateAnonymousResponse> {
    return fetchJSON<CreateAnonymousResponse>('/api/clients/create-anonymous', {
      method: 'POST',
      body: payload,
      requireAuth: false,
    });
  },
};


